import { PhoneSchema } from "../../../shared/models/PhoneSchema";
import { GroupFullSchema } from "../../InfoGroup/models/GroupFullSchema";

export class UserTemplateSchema {
  key?: string;
  name?: string;
  state?: string;
  description?: string;
  schema!: GroupFullSchema;
  phoneComponentList!: PhoneSchema[];
  dateCreated?: number | string;
  dateChanged?: number | string;
}
